// Centralized business types + roles labels (Arabic)
// Feb 2026 — expanded to cover schools, NGOs, services, professional offices, and more.

export const BUSINESS_TYPES = [
  // Primary business types used for new companies (kept separate from subscription_plan).
  { v: "retail", l: "🏪 متجر عام / تجزئة", group: "الأنشطة الأساسية" },
  { v: "pharmacy", l: "💊 صيدلية", group: "الأنشطة الأساسية" },
  { v: "restaurant", l: "🍽️ مطعم", group: "الأنشطة الأساسية" },
  { v: "clothing", l: "👕 ملابس وأحذية", group: "الأنشطة الأساسية" },
  { v: "electronics", l: "📱 إلكترونيات", group: "الأنشطة الأساسية" },
  { v: "grocery", l: "🛒 بقالة وسوبرماركت", group: "الأنشطة الأساسية" },
  { v: "services", l: "🛠️ خدمات ومهن", group: "الأنشطة الأساسية" },
  { v: "other", l: "📋 مجال آخر", group: "الأنشطة الأساسية" },
  // Original
  { v: "general_trading", l: "🏪 تجاري عام", group: "تجاري" },
  { v: "wholesale", l: "📦 جملة ومستودعات", group: "تجاري" },
  { v: "supermarket", l: "🛒 سوبر ماركت", group: "تجاري" },
  { v: "retail_clothing", l: "👔 محل ألبسة / أقمشة", group: "تجاري" },
  { v: "factory", l: "🏭 مصنع / إنتاج", group: "صناعي" },
  { v: "bakery", l: "🥐 حلويات / مخبز", group: "صناعي" },
  { v: "printing", l: "🖨️ مطبعة / تصميم مطبوعات", group: "صناعي" },
  // pharmacy is already listed among the primary business types above.
  { v: "clinic", l: "🩺 عيادة / مركز طبي", group: "طبي" },
  // restaurant is already listed among the primary business types above.
  { v: "hotel", l: "🏨 فندق / شقق فندقية", group: "ضيافة" },
  { v: "exchange", l: "💱 صرافة وحوالات", group: "مالي" },
  // NEW — Education
  { v: "school", l: "🎓 مدرسة خاصة / روضة", group: "تعليم" },
  { v: "university", l: "🎓 جامعة / معهد عالي", group: "تعليم" },
  { v: "training_center", l: "📚 مركز تدريب / دورات", group: "تعليم" },
  // NEW — NGO / Charity
  { v: "ngo", l: "🤝 منظمة غير ربحية", group: "غير ربحي" },
  { v: "charity", l: "🕊️ جمعية خيرية", group: "غير ربحي" },
  // NEW — Services
  // services is already listed among the primary business types above.
  { v: "car_service", l: "🚗 ورشة صيانة سيارات", group: "خدمات" },
  { v: "laundry", l: "🧺 مغسلة / كوي", group: "خدمات" },
  { v: "salon", l: "💇 صالون تجميل / حلاقة", group: "خدمات" },
  { v: "gym", l: "💪 نادي رياضي / جيم", group: "خدمات" },
  { v: "transport", l: "🚚 شركة نقل / شحن", group: "خدمات" },
  // NEW — Professional offices
  { v: "accounting_firm", l: "📊 مكتب محاسبة", group: "مكاتب مهنية" },
  { v: "law_firm", l: "⚖️ مكتب محاماة", group: "مكاتب مهنية" },
  { v: "engineering_office", l: "📐 مكتب هندسي", group: "مكاتب مهنية" },
  { v: "real_estate", l: "🏢 مكتب عقاري", group: "مكاتب مهنية" },
  { v: "media_agency", l: "🎬 وكالة إعلانات / إعلام", group: "مكاتب مهنية" },
  // NEW — Construction / Agriculture
  { v: "construction", l: "🏗️ شركة إنشاءات / مقاولات", group: "إنشاءات" },
  { v: "agriculture", l: "🌾 مزرعة / زراعة", group: "زراعة" },
];

export const ROLES = [
  // Core admin & management
  { v: "super_admin", l: "مدير عام", group: "الإدارة العامة" },
  { v: "company_manager", l: "مدير شركة", group: "الإدارة العامة" },
  { v: "office_manager", l: "مدير مكتب", group: "الإدارة العامة" },
  { v: "hr_officer", l: "موظف موارد بشرية", group: "الإدارة العامة" },
  { v: "secretary", l: "سكرتير / سكرتيرة", group: "الإدارة العامة" },
  { v: "customer_service", l: "خدمة عملاء", group: "الإدارة العامة" },
  { v: "security_guard", l: "حارس أمن", group: "الإدارة العامة" },
  { v: "office_boy", l: "🚶 مراسل / آفس بوي", group: "الإدارة العامة" },
  { v: "translator", l: "مترجم", group: "الإدارة العامة" },
  // Finance
  { v: "accountant", l: "محاسب", group: "المالية والمحاسبة" },
  { v: "auditor", l: "مدقق / مراجع", group: "المالية والمحاسبة" },
  { v: "cashier", l: "كاشير / أمين صندوق", group: "المالية والمحاسبة" },
  { v: "data_entry", l: "مدخل بيانات", group: "المالية والمحاسبة" },
  // Exchange & Remittances
  { v: "exchange_teller", l: "💱 صرّاف / أمين حوالات", group: "الصرافة والحوالات" },
  // Warehouse
  { v: "warehouse", l: "أمين مستودع", group: "المخزن واللوجستيات" },
  { v: "spare_parts_officer", l: "🔧 مسؤول قطع غيار", group: "المخزن واللوجستيات" },
  { v: "logistics_officer", l: "🚛 موظف لوجستيات", group: "المخزن واللوجستيات" },
  { v: "dispatcher", l: "📞 موظف إرسال / dispatcher", group: "المخزن واللوجستيات" },
  { v: "fleet_manager", l: "🚚 مدير أسطول", group: "المخزن واللوجستيات" },
  // Sales
  { v: "sales_rep", l: "مندوب مبيعات", group: "المبيعات والمشتريات" },
  { v: "purchase_officer", l: "موظف مشتريات", group: "المبيعات والمشتريات" },
  // Restaurant / Food Service
  { v: "waiter", l: "🍽️ نادل", group: "مطعم وضيافة طعام" },
  { v: "chef", l: "🍳 طاهي / شيف", group: "مطعم وضيافة طعام" },
  { v: "sous_chef", l: "👨‍🍳 مساعد شيف / سو شيف", group: "مطعم وضيافة طعام" },
  { v: "barista", l: "☕ باريستا", group: "مطعم وضيافة طعام" },
  { v: "delivery_driver", l: "🛵 سائق ديليفري", group: "مطعم وضيافة طعام" },
  { v: "kitchen_helper", l: "🍴 مساعد مطبخ", group: "مطعم وضيافة طعام" },
  { v: "bartender", l: "🍹 بارتندر", group: "مطعم وضيافة طعام" },
  // Medical / Clinic
  { v: "doctor", l: "🩺 طبيب", group: "طبي وصحي" },
  { v: "nurse", l: "💉 ممرّض / ممرّضة", group: "طبي وصحي" },
  { v: "receptionist", l: "📇 موظف استقبال (عيادة)", group: "طبي وصحي" },
  { v: "dentist", l: "🦷 طبيب أسنان", group: "طبي وصحي" },
  { v: "lab_technician", l: "🧪 فني مختبر", group: "طبي وصحي" },
  { v: "radiologist", l: "📡 فني أشعة", group: "طبي وصحي" },
  { v: "physiotherapist", l: "🦵 أخصائي علاج طبيعي", group: "طبي وصحي" },
  { v: "midwife", l: "👶 قابلة / داية", group: "طبي وصحي" },
  { v: "anesthesiologist", l: "😴 طبيب تخدير", group: "طبي وصحي" },
  // Pharmacy
  { v: "pharmacist", l: "💊 صيدلي", group: "صيدلية" },
  { v: "pharmacy_assistant", l: "🧴 مساعد صيدلي", group: "صيدلية" },
  // Education
  { v: "teacher", l: "👨‍🏫 معلم / أستاذ", group: "تعليم ومدارس" },
  { v: "principal", l: "🎓 مدير مدرسة", group: "تعليم ومدارس" },
  { v: "vice_principal", l: "🎓 نائب مدير مدرسة", group: "تعليم ومدارس" },
  { v: "registrar", l: "📚 مسجل طلاب", group: "تعليم ومدارس" },
  { v: "student_affairs", l: "🎒 شؤون الطلاب", group: "تعليم ومدارس" },
  { v: "librarian", l: "📖 أمين مكتبة", group: "تعليم ومدارس" },
  { v: "school_counselor", l: "🧑‍💼 مرشد اجتماعي / نفسي", group: "تعليم ومدارس" },
  { v: "lecturer", l: "🎤 محاضر / أستاذ جامعي", group: "تعليم ومدارس" },
  { v: "lab_supervisor", l: "🔬 مشرف مختبر", group: "تعليم ومدارس" },
  { v: "gym_coach", l: "🤸 مدرس تربية بدنية", group: "تعليم ومدارس" },
  { v: "bus_supervisor", l: "🚌 مشرف باص طلاب", group: "تعليم ومدارس" },
  // NGO / Charity
  { v: "program_manager", l: "🤝 مدير برنامج", group: "منظمات وجمعيات" },
  { v: "volunteer", l: "🌟 متطوع", group: "منظمات وجمعيات" },
  { v: "fundraiser", l: "💰 مسؤول جمع تبرعات", group: "منظمات وجمعيات" },
  { v: "field_officer", l: "🗺️ موظف ميداني", group: "منظمات وجمعيات" },
  { v: "project_coordinator", l: "📋 منسق مشروع", group: "منظمات وجمعيات" },
  { v: "social_worker", l: "🫂 أخصائي اجتماعي", group: "منظمات وجمعيات" },
  // Hotel
  { v: "hotel_receptionist", l: "🏨 موظف استقبال فندق", group: "فنادق وضيافة" },
  { v: "hotel_manager", l: "🏨 مدير فندق", group: "فنادق وضيافة" },
  { v: "housekeeping", l: "🛏️ تدبير منزلي / نظافة غرف", group: "فنادق وضيافة" },
  { v: "concierge", l: "🎩 كونسيرج", group: "فنادق وضيافة" },
  { v: "porter", l: "🧳 حمّال أمتعة / بورتر", group: "فنادق وضيافة" },
  { v: "chef_hotel", l: "🍳 شيف فندق", group: "فنادق وضيافة" },
  { v: "reservations_officer", l: "📅 موظف حجوزات", group: "فنادق وضيافة" },
  // Gym & Sports
  { v: "trainer", l: "💪 مدرب رياضي", group: "نوادي رياضية" },
  { v: "yoga_instructor", l: "🧘 مدرب يوغا", group: "نوادي رياضية" },
  { v: "swim_coach", l: "🏊 مدرب سباحة", group: "نوادي رياضية" },
  { v: "gym_receptionist", l: "📇 موظف استقبال نادي", group: "نوادي رياضية" },
  // Salon / Beauty
  { v: "stylist", l: "💇 مصفف شعر", group: "صالونات وتجميل" },
  { v: "makeup_artist", l: "💄 مكياج / خبير تجميل", group: "صالونات وتجميل" },
  { v: "nail_technician", l: "💅 فنية أظافر", group: "صالونات وتجميل" },
  { v: "spa_therapist", l: "🧖 معالج سبا / مساج", group: "صالونات وتجميل" },
  // Automotive
  { v: "mechanic", l: "🔧 ميكانيكي سيارات", group: "صيانة سيارات" },
  { v: "auto_electrician", l: "⚡ كهربائي سيارات", group: "صيانة سيارات" },
  { v: "body_repair", l: "🚗 حداد / سمكرة", group: "صيانة سيارات" },
  { v: "technician", l: "🛠️ فني عام", group: "صيانة سيارات" },
  { v: "driver", l: "🚚 سائق", group: "صيانة سيارات" },
  // Laundry / Cleaning
  { v: "laundry_operator", l: "🧺 مشغّل مغسلة", group: "مغاسل ونظافة" },
  { v: "presser", l: "👔 كوّاء", group: "مغاسل ونظافة" },
  { v: "cleaner", l: "🧹 عامل نظافة", group: "مغاسل ونظافة" },
  // Professional / Engineering
  { v: "engineer", l: "📐 مهندس", group: "مهن هندسية واستشارية" },
  { v: "civil_engineer", l: "🏗️ مهندس مدني", group: "مهن هندسية واستشارية" },
  { v: "electrical_engineer", l: "⚡ مهندس كهرباء", group: "مهن هندسية واستشارية" },
  { v: "mechanical_engineer", l: "⚙️ مهندس ميكانيك", group: "مهن هندسية واستشارية" },
  { v: "architect", l: "🏛️ معماري", group: "مهن هندسية واستشارية" },
  { v: "surveyor", l: "📏 مساح", group: "مهن هندسية واستشارية" },
  { v: "lawyer", l: "⚖️ محامي", group: "مهن هندسية واستشارية" },
  { v: "legal_assistant", l: "📄 مساعد قانوني", group: "مهن هندسية واستشارية" },
  { v: "consultant", l: "💼 مستشار", group: "مهن هندسية واستشارية" },
  // Real Estate
  { v: "real_estate_agent", l: "🏢 وسيط عقاري", group: "عقارات" },
  { v: "property_manager", l: "🏠 مدير عقارات", group: "عقارات" },
  { v: "leasing_officer", l: "📝 موظف إيجارات", group: "عقارات" },
  // Media / Marketing
  { v: "designer", l: "🎨 مصمم جرافيك", group: "إعلام وتسويق" },
  { v: "photographer", l: "📷 مصور", group: "إعلام وتسويق" },
  { v: "videographer", l: "🎬 مصور فيديو / مونتير", group: "إعلام وتسويق" },
  { v: "content_writer", l: "✍️ كاتب محتوى", group: "إعلام وتسويق" },
  { v: "marketing_officer", l: "📢 موظف تسويق", group: "إعلام وتسويق" },
  { v: "social_media_manager", l: "📱 مسؤول سوشيال ميديا", group: "إعلام وتسويق" },
  // Construction / Trades
  { v: "foreman", l: "👷 مشرف موقع / أسطى", group: "إنشاءات وحرف" },
  { v: "site_supervisor", l: "🏗️ مسؤول موقع", group: "إنشاءات وحرف" },
  { v: "labor", l: "💪 عامل بناء", group: "إنشاءات وحرف" },
  { v: "crane_operator", l: "🏗️ مشغّل رافعة", group: "إنشاءات وحرف" },
  { v: "safety_officer", l: "⛑️ موظف سلامة", group: "إنشاءات وحرف" },
  { v: "carpenter", l: "🪚 نجار", group: "إنشاءات وحرف" },
  { v: "electrician", l: "⚡ كهربائي", group: "إنشاءات وحرف" },
  { v: "plumber", l: "🚿 سبّاك", group: "إنشاءات وحرف" },
  { v: "painter", l: "🎨 دهّان", group: "إنشاءات وحرف" },
  { v: "welder", l: "🔥 حداد / لحّام", group: "إنشاءات وحرف" },
  // Agriculture
  { v: "farmer", l: "🌾 مزارع", group: "زراعة وثروة حيوانية" },
  { v: "agronomist", l: "🌱 مهندس زراعي", group: "زراعة وثروة حيوانية" },
  { v: "farm_worker", l: "🚜 عامل مزرعة", group: "زراعة وثروة حيوانية" },
  { v: "veterinarian", l: "🐄 طبيب بيطري", group: "زراعة وثروة حيوانية" },
  // IT / Tech
  { v: "developer", l: "💻 مطوّر / مبرمج", group: "تقنية ومعلومات" },
  { v: "sysadmin", l: "🖥️ مسؤول أنظمة", group: "تقنية ومعلومات" },
  // Support
  { v: "support", l: "🎧 دعم فني", group: "الدعم" },
];

export const roleLabel = (v) => ROLES.find(r => r.v === v)?.l || v;
export const businessTypeLabel = (v) => BUSINESS_TYPES.find(b => b.v === v)?.l || v;

// Group business types for grouped select rendering
export const groupedBusinessTypes = () => {
  const groups = {};
  BUSINESS_TYPES.forEach(b => {
    if (!groups[b.group]) groups[b.group] = [];
    groups[b.group].push(b);
  });
  return groups;
};

export const groupedRoles = () => {
  const groups = {};
  ROLES.forEach(r => {
    if (!groups[r.group]) groups[r.group] = [];
    groups[r.group].push(r);
  });
  return groups;
};
